module.exports = __webpack_public_path__ + "media/images/pages/ai/icon-cultural-b53beda1e6eb79df9ed03e06b75a33f2.svg";